module.exports = __webpack_public_path__ + "static/media/cloudcards.e3cd9c10.png";